var map = {
	"src/app/change-password/change-password.module": [
		"./src/app/change-password/change-password.module.ts",
		"src-app-change-password-change-password-module"
	],
	"src/app/home/home.module": [
		"./src/app/home/home.module.ts",
		"src-app-home-home-module"
	],
	"src/app/npp-dashboard/npp-dashboard.module": [
		"./src/app/npp-dashboard/npp-dashboard.module.ts",
		"src-app-npp-dashboard-npp-dashboard-module"
	],
	"src/app/usermanagement/user/activeuser/activeuser.module": [
		"./src/app/usermanagement/user/activeuser/activeuser.module.ts",
		"common",
		"src-app-usermanagement-user-activeuser-activeuser-module"
	],
	"src/app/usermanagement/user/activeuser/external-user/external-user.module": [
		"./src/app/usermanagement/user/activeuser/external-user/external-user.module.ts",
		"common",
		"src-app-usermanagement-user-activeuser-external-user-external-user-module"
	],
	"src/app/usermanagement/user/activeuser/internal-user/internal-user.module": [
		"./src/app/usermanagement/user/activeuser/internal-user/internal-user.module.ts",
		"common",
		"src-app-usermanagement-user-activeuser-internal-user-internal-user-module"
	],
	"src/app/usermanagement/user/inactiveuser/inactiveuser.module": [
		"./src/app/usermanagement/user/inactiveuser/inactiveuser.module.ts",
		"common",
		"src-app-usermanagement-user-inactiveuser-inactiveuser-module"
	],
	"src/app/usermanagement/user/user.module": [
		"./src/app/usermanagement/user/user.module.ts",
		"default~src-app-usermanagement-user-user-module~src-app-usermanagement-usermanagement-module",
		"common",
		"src-app-usermanagement-user-user-module"
	],
	"src/app/usermanagement/usermanagement.module": [
		"./src/app/usermanagement/usermanagement.module.ts",
		"default~src-app-usermanagement-user-user-module~src-app-usermanagement-usermanagement-module",
		"common",
		"src-app-usermanagement-usermanagement-module"
	],
	"src/app/vave/vave.module": [
		"./src/app/vave/vave.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;